module.exports = __webpack_public_path__ + "img/steps-01.f7f2fe93.png";